module.exports = __webpack_public_path__ + "static/media/artist-post-production.038b4de2.jpg";